// extracted by mini-css-extract-plugin
export default {"wrapper":"InnerPageLayout_wrapper__pHnBY"};